import { FundAdminRequestedServiceObjects } from "./types";

export const hasSingleUserObject = (objects: FundAdminRequestedServiceObjects) =>
  objects.length === 1 && objects[0].objectValue.__typename === "UserObjectType";

export const hasObjectsWithAmounts = (objects: FundAdminRequestedServiceObjects) =>
  objects.some(
    (object) =>
      Boolean(object.objectDetails) &&
      object.objectDetails !== "{}" &&
      Boolean(JSON.parse(object.objectDetails ?? "")?.amount),
  );
